<article
  (keydown)="onGlobalKeyDown($event)"
  tabindex="-1"
  #dashboardContainer
  [class.restaurant-layout]="isRestaurantIndustry"
>
  <!-- Skip to content link for accessibility -->
  <a href="#main-content" class="skip-link">Skip to main content</a>

  <!-- ═══════════════════════════════════════════════════════════════════════
       RETAIL / MOBILE layout — shown for all non-Restaurant industries.
       The inner HTML is UNCHANGED — only wrapped in an ngIf.
       ═══════════════════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="!isRestaurantIndustry">
    <div
      class="section-container"
      id="main-content"
      [attr.inert]="showTransactionDialog || savedReceiptsDialog ? '' : null"
    >
      <!-- section 1 -->
      <div class="section-wrapper">
        <div
          class="section section-2 product-search"
          [class.disabled-section]="isExchangeOrder"
          [class.barcode-hidden]="!isBarcodeEnabled"
        >
          <!-- Left side: Barcode Search -->
          <div
            class="search-input-group barcode-search"
            *ngIf="isBarcodeEnabled"
          >
            <div
              class="barcode-input-container"
              [class.delete-mode]="isDeleteMode"
            >
              <input
                type="text"
                class="form-control barcode-input"
                [class.delete-mode]="isDeleteMode"
                placeholder="Scan barcode"
                [(ngModel)]="barcodeInput"
                (keydown.enter)="onBarcodeEnter()"
                (input)="onBarcodeInput()"
                (blur)="onBarcodeBlur()"
                tabindex="1"
                #barcodeSearchInput
                [disabled]="isExchangeOrder"
                title="Press Ctrl+1 to focus here"
              />
              <span class="kbd search-kbd" aria-hidden="true">Ctrl 1</span>
              <button
                type="button"
                class="barcode-icon"
                (click)="!isExchangeOrder && toggleQR()"
                [class.disabled]="isExchangeOrder"
                [disabled]="isExchangeOrder"
                title="Scan with camera"
                aria-label="Scan with camera"
              >
                <i class="pi pi-barcode" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <!-- Right side: Product Search -->
          <div class="search-input-group product-search-group">
            <div class="product-input-container">
              <i class="pi pi-search search-icon" aria-hidden="true"></i>
              <p-autoComplete
                [(ngModel)]="itemId"
                appendTo="body"
                panelStyleClass="enhanced-autocomplete-panel"
                scrollHeight="none"
                #autoCompleteInput
                [autofocus]="enableCursorFocus"
                [suggestions]="filteredProducts"
                [minLength]="1"
                [delay]="200"
                (completeMethod)="populateFilterProducts($event)"
                [showEmptyMessage]="true"
                [emptyMessage]="'No Match Found, Try Again'"
                (ngModelChange)="populateFilterProducts($event)"
                (onSelect)="selectProduct($event)"
                (onShow)="attachAutocompleteScrollListener()"
                (onHide)="detachAutocompleteScrollListener()"
                field="name"
                [dropdown]="true"
                [forceSelection]="false"
                [autoHighlight]="false"
                (keydown.enter)="enterSelected()"
                [disabled]="isExchangeOrder"
                placeholder="Search product by name or code"
                [tabindex]="2"
                styleClass="w-100"
                title="Press Ctrl+2 to focus here"
              >
                <!--<ng-template pTemplate="item" let-product>
                            {{ product.name }} {{ (isWholesaleMode ? product.wholesaleprice : product.sellingprice) | number:'1.2-2' }}
                        </ng-template>-->
                <ng-template pTemplate="header">
                  <div class="autocomplete-header">
                    <div class="header-row">
                      <!-- <div class="header-cell code-col">CODE</div> -->
                      <div class="header-cell name-col">NAME</div>
                      <div class="header-cell brand-col">BRAND</div>
                      <div class="header-cell rack-col">RACK</div>
                      <div class="header-cell price-col">S.PRICE</div>
                      <div class="header-cell qty-col">QTY</div>
                    </div>
                  </div>
                </ng-template>
                <ng-template let-product pTemplate="item" let-i="index">
                  <div class="autocomplete-item">
                    <div class="item-row">
                      <!-- <div class="item-cell code-col">{{ i + 1 }}</div> -->
                      <div class="item-cell name-col">
                        <div class="product-name">{{ product.name }}</div>
                        <div class="product-details">
                          <div class="details-line">
                            <span class="barcode-text" *ngIf="isBarcodeEnabled"
                              >Barcode:
                              {{
                                displayBarcode(product) || "No Barcode"
                              }}</span
                            >
                            <span
                              class="separator"
                              *ngIf="isBarcodeEnabled && isBatchEnabled"
                            >
                              |
                            </span>
                            <span class="batch-text" *ngIf="isBatchEnabled"
                              >Batch:
                              {{
                                product.batch == "opens012"
                                  ? "Opening stock"
                                  : product.batch || "--"
                              }}</span
                            >
                          </div>
                          <div class="details-line">
                            <span
                              class="category-text"
                              *ngIf="product.category"
                              >{{ product.category }}</span
                            >
                            <span
                              class="separator"
                              *ngIf="product.category && product.subcategory"
                            >
                              >
                            </span>
                            <span
                              class="subcategory-text"
                              *ngIf="product.subcategory"
                              >{{ product.subcategory }}</span
                            >
                            <span
                              class="separator"
                              *ngIf="
                                (product.category || product.subcategory) &&
                                product.sku
                              "
                            >
                              |
                            </span>
                            <span class="variant-text" *ngIf="product.sku"
                              >SKU: {{ product.sku }}</span
                            >
                            <ng-container *ngIf="isPharmacyIndustry">
                              <br />
                              <span class="expiry-text"
                                >Expiry Date :
                                {{ product.expirydate || "-" }}</span
                              >
                              <span class="separator">|</span>
                              <span class="schedule-text"
                                >Schedule Type :
                                {{ product.scheduledtype || "-" }}</span
                              >
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div class="item-cell brand-col">
                        {{ product?.brand || "--" }}
                      </div>
                      <div class="item-cell rack-col">{{ product?.rack }}</div>
                      <div class="item-cell price-col">
                        {{
                          (isWholesaleMode
                            ? product.wholesaleprice
                            : isUnitPriceInclTax
                              ? product.sellingpriceincl|| product.sellingprice
                              : product.sellingpriceexcl || product.sellingprice
                          ) | number: "1.2-2"
                        }}
                      </div>
                      <!-- <div
                        class="item-cell price-col"
                        *ngIf="isUnitPriceInclTax"
                      >
                        {{
                          product.product_selling_price_incl
                            | currency: "INR" : "symbol" : "1.0-2"
                        }}
                      </div> -->
                      <div class="item-cell qty-col">
                        <span class="qty-badge">{{
                          product?.product_type === "Non Stock"
                            ? "NULL"
                            : getdecimalval(product?.qty) || 0
                        }}</span>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-autoComplete>
              <span class="kbd search-kbd" aria-hidden="true">Ctrl 2</span>
            </div>
          </div>
        </div>
        <!-- section 2 -->
        <div
          class="section section-1 table-custom-scroll"
          [class.quotation-mode]="isQuotationMode"
          [class.wholesale-mode]="isWholesaleMode"
          [class.offer-group-mode]="isOfferGroupMode"
          [class.delete-mode]="isDeleteMode"
        >
          <!-- Show table when data exists -->
          <ng-container *ngIf="products && products.length > 0">
            <table class="table custom-table table-bordered">
              <thead class="fixed-header">
                <tr>
                  <th
                    class="col-select"
                    *ngIf="
                      industryConfig.table.showSerialNo && !isExchangeOrder
                    "
                  >
                    <p-checkbox
                      [(ngModel)]="selectAll"
                      [binary]="true"
                      (onChange)="onSelectAllToggle($event)"
                      title="Select All"
                      styleClass="select-all-checkbox"
                    >
                    </p-checkbox>
                  </th>
                  <th
                    class="col-barcode text-start"
                    *ngIf="industryConfig.table.showCode && isBarcodeEnabled"
                  >
                    Barcode
                  </th>

                  <th
                    *ngIf="isSuspenseMode"
                    class="col-exclude-gst text-center"
                  >
                    Exclude GST
                  </th>

                  <th
                    class="col-item-name text-start"
                  >
                    {{ industryConfig.table.itemNameLabel }}
                  </th>

                  <th *ngIf="isBatchEnabled" class="col-batch text-start">
                    Batch
                  </th>

                  <th
                    *ngIf="industryConfig.table.showManufacturer"
                    class="col-manufacturer text-center"
                  >
                    Manufacturer
                  </th>

                  <th
                    *ngIf="industryConfig.table.showMapping"
                    class="col-mapping text-start"
                  >
                    Mapping
                  </th>

                  <!--<th style="width: 7%;">MRP</th>-->

                  <th
                    *ngIf="
                      industryConfig.table.industry !== INDUSTRY_ENUM.MOBILE
                    "
                    class="col-unit text-center"
                  >
                    Unit
                  </th>
                  <th class="col-qty">Qty</th>
                  <!-- Free Qty column: shown only when any cart item has free_qty > 0 -->
                  <th
                    *ngIf="
                      !isExchangeOrder &&
                      hasFreeQtyProducts() &&
                      isFreeQtyEnabled &&
                      enableFreeQty
                    "
                    class="col-free-qty text-center"
                  >
                    Free Qty
                  </th>

                  <th *ngIf="isExchangeOrder" class="col-return-qty text-end">
                    Return Qty
                  </th>
                  <th *ngIf="!isExchangeOrder" class="col-disc">
                    <div class="discount-header">
                      <span>Disc</span>
                      <div
                        class="discount-switch-container"
                        *ngIf="
                          isSalesDiscountEditEnabled ||
                          industryConfig.table.industry == INDUSTRY_ENUM.MOBILE
                        "
                      >
                        <span
                          class="switch-label"
                          [class.active]="discountMode === 'percentage'"
                          >%</span
                        >
                        <p-inputSwitch
                          [(ngModel)]="isAmountMode"
                          (onChange)="onDiscountToggle($event)"
                          styleClass="discount-toggle-switch"
                          [title]="
                            isAmountMode
                              ? 'Switch to Percentage'
                              : 'Switch to Amount'
                          "
                        >
                        </p-inputSwitch>
                        <span
                          class="switch-label"
                          [class.active]="discountMode === 'amount'"
                          >₹</span
                        >
                      </div>
                    </div>
                  </th>
                  <th class="col-unit-price text-end">Unit Price</th>
                  <th class="col-tax text-end">Tax</th>
                  <th class="col-net-value text-end">Net Value</th>
                  <th
                    *ngIf="!isExchangeOrder && products && products.length > 0"
                    class="col-action text-center"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container
                  *ngFor="
                    let product of products;
                    trackBy: trackByProductId;
                    let i = index
                  "
                >
                  <tr
                    (click)="
                      onSelectProduct(product.productId, product.psid, true)
                    "
                    (keydown.enter)="
                      onSelectProduct(product.productId, product.psid, true)
                    "
                    (keydown.space)="
                      onSelectProduct(product.productId, product.psid, true)
                    "
                    [class.selected]="currentPSID === product.psid"
                    [class.bounced]="isBouncing && currentPSID === product.psid"
                    [class.exchange-item]="product.returned === true"
                    [class.being-exchanged]="
                      product.returned === true &&
                      isExchangeOrder &&
                      (product.exchangeQuantity || 0) > 0
                    "
                    [class.available-for-exchange]="
                      product.returned === true &&
                      isExchangeOrder &&
                      (product.exchangeQuantity || 0) === 0
                    "
                    [tabindex]="3 + i"
                    role="button"
                    [attr.aria-label]="
                      'Product: ' +
                      product.name +
                      ', Price: ' +
                      ((isWholesaleMode
                        ? product.wholesaleprice
                        : product.sellingprice
                      ) | currency: 'INR')
                    "
                  >
                    <td
                      *ngIf="
                        industryConfig.table.showSerialNo && !isExchangeOrder
                      "
                    >
                      <p-checkbox
                        [(ngModel)]="product.selected"
                        [binary]="true"
                        title="Select All"
                        styleClass="select-all-checkbox"
                        (click)="selectFreeProduct(product)"
                      >
                      </p-checkbox>
                    </td>
                    <td
                      class="text-start barcode-cell"
                      *ngIf="industryConfig.table.showCode && isBarcodeEnabled"
                    >
                      <span class="item-id-text">{{
                        displayBarcode(product) || "--"
                      }}</span>
                    </td>

                    <td *ngIf="isSuspenseMode" class="text-center">
                      <p-checkbox
                        [(ngModel)]="product.selected"
                        [binary]="true"
                        (onChange)="onProductGSTToggle(product)"
                        [title]="
                          product.selected
                            ? 'No GST (isgst=0)'
                            : 'With GST (isgst=1)'
                        "
                        styleClass="gst-checkbox"
                      >
                      </p-checkbox>
                    </td>
                    <td class="text-start name-cell">
                      <div class="product-name-container">
                        <div class="product-name-row">
                          <span class="product-name" [title]="product.name">{{
                            product.name
                          }}</span>

                          <!-- Status tags: return / free -->
                          <span
                            *ngIf="product.returned === true && isExchangeOrder && (product.exchangeQuantity || 0) > 0"
                            class="row-tag row-tag--exchange"
                            title="Being returned"
                            ><i class="pi pi-refresh"></i>Returning</span
                          >
                          <span
                            *ngIf="product.returned === true && isExchangeOrder && (product.exchangeQuantity || 0) === 0"
                            class="row-tag row-tag--muted"
                            title="Available for return"
                            ><i class="pi pi-clock"></i>Available</span
                          >
                          <span *ngIf="product.returned === true && !isExchangeOrder" class="row-tag row-tag--exchange" title="Return item"
                            ><i class="pi pi-refresh"></i>Return</span
                          >
                          <span *ngIf="product.isFree && isFreeQtyEnabled" class="row-tag row-tag--success" title="Free item"
                            ><i class="pi pi-tag"></i>Free</span
                          >
                          <button
                            type="button"
                            *ngIf="(product.free_qty || 0) > 0 && !isExchangeOrder && isFreeQtyEnabled && !isQuotationMode"
                            class="row-tag row-tag--success row-tag--action"
                            (click)="showFreeQtyCol()"
                            title="Free quantity available"
                          >
                            <i class="pi pi-gift"></i>Free available
                          </button>

                          <!-- Row tools sit right after the name, the same on every industry and screen width -->
                          <span class="row-icons">
                            <button
                              type="button"
                              class="row-icon"
                              (click)="showProductDetails(product)"
                              title="View product details"
                              aria-label="View product details"
                            >
                              <i class="pi pi-info-circle"></i>
                            </button>
                            <button
                              type="button"
                              class="row-icon"
                              [class.is-set]="product.description && product.description.trim()"
                              (click)="openDescriptionDialog(product); $event.stopPropagation()"
                              [title]="
                                product.description && product.description.trim()
                                  ? 'Edit description: ' + product.description
                                  : 'Add description'
                              "
                              aria-label="Item description"
                            >
                              <i class="pi pi-file-edit"></i>
                            </button>
                            <button
                              type="button"
                              *ngIf="industryConfig.table.industry == INDUSTRY_ENUM.MOBILE"
                              class="row-icon"
                              [class.is-set]="!!product.warranty_date"
                              (click)="openWarrantyDialog(product); $event.stopPropagation()"
                              [title]="
                                product.warranty_date
                                  ? 'Warranty till: ' + (product.warranty_date | date: 'dd-MM-yyyy')
                                  : 'Add warranty date'
                              "
                              aria-label="Warranty date"
                            >
                              <i class="pi pi-shield"></i>
                            </button>
                          </span>
                        </div>

                        <app-variant-selector
                          *ngIf="product.productmapvalues?.length || product.selectedMapValue"
                          [product]="product"
                          [openSignal]="selectedVariantProduct === product ? variantOpenTick : 0"
                          (variantSelected)="onVariantSelected(product, $event)"
                          (openSignalConsumed)="onVariantOpenSignalConsumed(product)"
                        >
                        </app-variant-selector>

                        <!-- Meta line: barcode, tax rates, pharmacy expiry / schedule -->
                        <div class="product-meta">
                          <!-- shown only when the Barcode column is hidden on narrow screens -->
                          <span
                            class="meta-item meta-barcode num"
                            *ngIf="industryConfig.table.showCode && isBarcodeEnabled && displayBarcode(product)"
                            >{{ displayBarcode(product) }}</span
                          >
                          <span
                            class="meta-item num"
                            *ngIf="!industryConfig.table.showCode && isBarcodeEnabled && displayBarcode(product)"
                            >{{ displayBarcode(product) }}</span
                          >
                          <ng-container *ngIf="industryConfig.table.showCode">
                            <span
                              *ngIf="
                                isInterStateTax() &&
                                ((product.itax || 0) > 0 || (product.ctax || 0) > 0 || (product.stax || 0) > 0)
                              "
                              class="meta-item tax-badge"
                              >IGST
                              {{
                                ((product.itax || 0) > 0 ? product.itax : (product.ctax || 0) + (product.stax || 0))
                                  | number: "1.0-2"
                              }}%</span
                            >
                            <span *ngIf="!isInterStateTax() && product.ctax && product.ctax > 0" class="meta-item tax-badge"
                              >CGST {{ product.ctax | number: "1.0-2" }}%</span
                            >
                            <span *ngIf="!isInterStateTax() && product.stax && product.stax > 0" class="meta-item tax-badge"
                              >SGST {{ product.stax | number: "1.0-2" }}%</span
                            >
                            <span *ngIf="product.cess && product.cess > 0" class="meta-item tax-badge"
                              >CESS {{ product.cess | number: "1.0-2" }}%</span
                            >
                          </ng-container>
                          <ng-container *ngIf="isPharmacyIndustry">
                            <span class="meta-item">Exp {{ product.expirydate || "—" }}</span>
                            <span class="meta-item">Sch {{ product.scheduledtype || "—" }}</span>
                          </ng-container>
                        </div>
                      </div>
                    </td>
                    <td *ngIf="isBatchEnabled" class="text-start batch-cell">
                      {{
                        (product.selectedMapValue?.batch ||
                          product.batch ||
                          product.batchid) == "opens012"
                          ? "Opening stock"
                          : product.selectedMapValue?.batch ||
                            product.batch ||
                            product.batchid
                      }}
                    </td>

                    <td
                      *ngIf="industryConfig.table.showManufacturer"
                      class="text-center manufacturer-cell"
                    >
                      {{ product.manufacturer || "—" }}
                    </td>
                    <td *ngIf="industryConfig.table.showMapping">
                      <p-dropdown
                        [options]="product.mappings"
                        [(ngModel)]="product.selectedMappingId"
                        placeholder="Mapping"
                        optionLabel="name"
                        optionValue="id"
                        styleClass="p-inputtext-sm w-100"
                        appendTo="body"
                        [disabled]="!!isExchangeOrder || !!product.returned"
                        (onChange)="onMappingSelected(product, $event)"
                      ></p-dropdown>
                    </td>
                    <!-- <td
                    *ngIf="industryConfig.table.showVariants"
                    class="text-center align-middle"
                    style="
                      min-width: 100px;
                      max-width: 120px;
                      position: relative;
                    "
                  > -->
                    <!-- Legacy mapping logic here, replaced by VariantSelectorComponent.
                         When variant table config is refactored, use VariantSelectorComponent instead -->
                    <!-- <app-variant-selector
                      *ngIf="hasVariantSelection(product)"
                      [product]="product"
                      (variantSelected)="selectVariantOption(product, $event)"
                    >
                    </app-variant-selector> -->
                    <!-- <span
                      *ngIf="!hasVariantSelection(product)"
                      class="text-muted"
                      >-</span
                    > -->
                    <!-- </td> -->
                    <!--<td class="rightaign">{{ product.sellingmrp| currency:'INR' }}</td>-->
                    <td
                      *ngIf="
                        industryConfig.table.industry !== INDUSTRY_ENUM.MOBILE
                      "
                    >
                      <!-- Multi-unit selector: only shown for bulk products when multiunit setting is on -->
                      <div
                        *ngIf="product.isbulk && product.unit_mappings?.length"
                        class="unit-select"
                      >
                        <p-dropdown
                          [options]="product.unit_mappings"
                          [(ngModel)]="product.unit_id"
                          (ngModelChange)="onSaleUnitChange(product)"
                          (click)="$event.stopPropagation()"
                          optionValue="unitid"
                          optionLabel="unitdetails.displayname"
                          styleClass="unit-mapping-dropdown"
                          appendTo="body"
                          [placeholder]="'Unit'"
                          [disabled]="isExchangeOrder"
                        >
                          <ng-template pTemplate="selectedItem" let-m>
                            {{
                              m?.unitdetails?.displayname ||
                                m?.unitdetails?.name ||
                                m?.displayname ||
                                m?.unitname
                            }}
                          </ng-template>
                          <ng-template pTemplate="item" let-m>
                            {{
                              m?.unitdetails?.displayname ||
                                m?.unitdetails?.name ||
                                m?.displayname ||
                                m?.unitname
                            }}
                          </ng-template>
                        </p-dropdown>
                      </div>
                      <div
                        *ngIf="
                          !product.isbulk || !product.unit_mappings?.length
                        "
                        class="unit-text"
                      >
                        {{
                          product.unit_mappings?.[0]?.unitdetails
                            ?.displayname ||
                            product.unit_mappings?.[0]?.unitdetails?.name ||
                            product.uom ||
                            "Base"
                        }}
                      </div>
                    </td>
                    <td class="qty-cell">
                      <div
                        class="qty-stack"
                        [class.has-stock]="
                          !isExchangeOrder &&
                          !product.returned &&
                          product.product_type !== 'Non Stock' &&
                          !isQuotationMode
                        "
                      >
                        <!-- Show quantity controls only when NOT in Return mode -->
                        <ng-container *ngIf="!isExchangeOrder">
                          <!-- Returned products: Keep existing +/- buttons -->
                          <ng-container *ngIf="product.returned === true">
                            <i
                              class="pi pi-minus-circle negativei p-2 return-qty-icon"
                              (click)="
                                decreaseQuantity(product);
                                $event.stopPropagation()
                              "
                            ></i>
                            <i
                              class="pi pi-plus-circle successi m-2 return-qty-icon"
                              (click)="
                                increaseQuantity(product);
                                $event.stopPropagation()
                              "
                            ></i>
                            <label class="m-1">{{
                              product.increaseQuantity
                            }}</label>
                          </ng-container>

                          <!-- Normal products: Enhanced quantity controls with stock validation -->
                          <ng-container *ngIf="!product.returned">
                            <div
                              class="quantity-controls quantity-controls-styled"
                            >
                              <button
                                type="button"
                                class="btn btn-sm quantity-btn quantity-minus quantity-btn-styled"
                                (click)="
                                  decreaseQuantity(product);
                                  $event.stopPropagation()
                                "
                                [disabled]="
                                  product.increaseQuantity <= 1 ||
                                  (industryConfig.table.showVariants &&
                                    requiresSelectionBeforeQuantity(product))
                                "
                                title="Decrease quantity"
                              >
                                <i class="pi pi-minus quantity-icon"></i>
                              </button>
                              <input
                                type="number"
                                class="form-control form-control-sm quantity-input quantity-input-styled"
                                [(ngModel)]="product.increaseQuantity"
                                [min]="getMinQuantityForProduct(product)"
                                [step]="
                                  canProductUseDecimals(product) ? 0.01 : 1
                                "
                                [max]="
                                  product.product_type === 'Non Stock'
                                    ? null
                                    : getMaxQuantityForProduct(product)
                                "
                                (input)="onQuantityChange(product)"
                                (blur)="onQuantityFocusOut(product)"
                                (click)="$event.stopPropagation()"
                                (keydown.tab)="onQuantityInputTab($event, i)"
                                [title]="
                                  product.product_type === 'Non Stock'
                                    ? 'Current quantity (no limit)'
                                    : 'Current quantity (' +
                                      getDisplayStockQty(product) +
                                      ' more available)'
                                "
                              />
                              <button
                                type="button"
                                class="btn btn-sm quantity-btn quantity-plus quantity-btn-styled quantity-plus-styled"
                                (click)="
                                  increaseQuantity(product);
                                  $event.stopPropagation()
                                "
                                [disabled]="
                                  (product.product_type !== 'Non Stock' &&
                                    product.increaseQuantity >=
                                      getMaxQuantityForProduct(product)) ||
                                  (industryConfig.table.showVariants &&
                                    requiresSelectionBeforeQuantity(product))
                                "
                                title="Increase quantity"
                              >
                                <i class="pi pi-plus quantity-icon"></i>
                              </button>
                            </div>

                            <div
                              class="stock-info stock-info-styled"
                              *ngIf="
                                product.product_type !== 'Non Stock' &&
                                !isQuotationMode
                              "
                            >
                              <small class="stock-badge num">{{ getDisplayStockQty(product) }} in stock</small>
                            </div>
                          </ng-container>
                        </ng-container>

                        <!-- Return mode: Keep existing label display -->
                        <ng-container *ngIf="isExchangeOrder">
                          <label class="m-1">{{
                            product.increaseQuantity
                          }}</label>
                        </ng-container>
                      </div>
                    </td>

                    <!-- Single Free Qty Column: Header and Cell conditions match 1:1 -->
                    <td
                      *ngIf="
                        !isExchangeOrder &&
                        hasFreeQtyProducts() &&
                        isFreeQtyEnabled &&
                        enableFreeQty
                      "
                      class="text-center free-qty-cell"
                    >
                      <!-- If item has free quantity stock available, show stepper controls -->
                      <ng-container
                        *ngIf="
                          (product.free_qty_available || 0) > 0;
                          else noFreeQty
                        "
                      >
                        <ng-container *ngIf="!product.returned">
                          <div
                            class="quantity-controls quantity-controls-styled free-qty-controls"
                          >
                            <button
                              type="button"
                              class="btn btn-sm quantity-btn quantity-minus quantity-btn-styled"
                              (click)="
                                decreaseFreeQty(product);
                                $event.stopPropagation()
                              "
                              [disabled]="(product.cart_free_qty || 0) <= 0"
                              title="Decrease free quantity"
                            >
                              <i class="pi pi-minus quantity-icon"></i>
                            </button>
                            <input
                              type="number"
                              class="form-control form-control-sm quantity-input quantity-input-styled"
                              [(ngModel)]="product.cart_free_qty"
                              [min]="0"
                              [max]="product.free_qty_available || 0"
                              [step]="canProductUseDecimals(product) ? 0.01 : 1"
                              (input)="onFreeQtyChange(product)"
                              (blur)="onFreeQtyFocusOut(product)"
                              (click)="$event.stopPropagation()"
                              placeholder="0"
                            />
                            <button
                              type="button"
                              class="btn btn-sm quantity-btn quantity-plus quantity-btn-styled quantity-plus-styled"
                              (click)="
                                increaseFreeQty(product);
                                $event.stopPropagation()
                              "
                              [disabled]="
                                (product.cart_free_qty || 0) >=
                                (product.free_qty_available || 0)
                              "
                              title="Increase free quantity"
                            >
                              <i class="pi pi-plus quantity-icon"></i>
                            </button>
                          </div>
                          <div class="stock-info stock-info-styled">
                            <small class="stock-badge num">{{ product.free_qty_available }} free in stock</small>
                          </div>
                        </ng-container>
                        <span
                          *ngIf="product.returned"
                          class="text-muted free-qty-dash"
                          >—</span
                        >
                      </ng-container>

                      <!-- Fallback: Always renders a dash if free stock is 0 or undefined -->
                      <ng-template #noFreeQty>
                        <span>-</span>
                      </ng-template>
                    </td>

                    <!-- Return Quantity Column - Only visible in Return mode -->

                    <td *ngIf="isExchangeOrder" class="text-center">
                      <div class="exchange-qty-container">
                        <button
                          type="button"
                          class="btn btn-sm exchange-qty-btn exchange-qty-minus"
                          (click)="
                            decreaseExchangeQuantity(product);
                            $event.stopPropagation()
                          "
                          [disabled]="
                            (product.exchangeQuantity || 0) <= 0 ||
                            product.isFree
                          "
                          title="Decrease return quantity"
                        >
                          <i class="pi pi-minus"></i>
                        </button>
                        <input
                          type="number"
                          class="form-control form-control-sm exchange-qty-input"
                          [(ngModel)]="product.exchangeQuantity"
                          [min]="0"
                          [max]="product.increaseQuantity"
                          [disabled]="product.isFree"
                          (input)="onExchangeQuantityChange(product)"
                          (click)="$event.stopPropagation()"
                          placeholder="0"
                          title="Return quantity (max: {{
                            product.increaseQuantity
                          }})"
                          [attr.data-exchange-index]="i"
                          (keydown)="onExchangeQuantityTab($event, i)"
                        />
                        <button
                          type="button"
                          class="btn btn-sm exchange-qty-btn exchange-qty-plus"
                          (click)="
                            increaseExchangeQuantity(product);
                            $event.stopPropagation()
                          "
                          [disabled]="
                            (product.exchangeQuantity || 0) >=
                              product.increaseQuantity || product.isFree
                          "
                          title="Increase return quantity"
                        >
                          <i class="pi pi-plus"></i>
                        </button>
                      </div>
                    </td>
                    <td *ngIf="!isExchangeOrder" class="discount-cell">
                      <!--{{ (product.sellingmrp - product.sellingprice )| currency:'INR' }}-->
                      <span *ngIf="product.returned === true">
                        {{ product.discount }}</span
                      >
                      <span
                        *ngIf="
                          product.returned !== true &&
                          isSalesDiscountEditEnabled
                        "
                        ><input
                          class="form-control form-control-sm discount-input text-end"
                          type="number"
                          [value]="
                            product.discount === 0 ? '' : product.discount
                          "
                          (input)="ondiscountvaluechange($event, product)"
                          (blur)="onDiscountBlur($event, product)"
                          (keydown)="onAmountInputTab($event, i)"
                          [min]="0"
                          [max]="
                            discountMode === 'percentage'
                              ? 100
                              : getEffectiveBasePrice(product)
                          "
                          step="1"
                          placeholder="Discount"
                      /></span>
                      <span
                        class="text-end"
                        *ngIf="
                          product.returned !== true &&
                          !isSalesDiscountEditEnabled
                        "
                      >
                        {{ product.discount || 0 }}
                      </span>
                    </td>
                    <td class="text-end unit-price-cell">
                      <!-- Editable: wholesale mode — always wholesaleprice, unaffected by incl-tax setting -->
                      <span *ngIf="isSalesPriceEditEnabled && isWholesaleMode">
                        <input
                          *ngIf="!isExchangeOrder"
                          class="form-control form-control-sm discount-input wholesale-input"
                          type="number"
                          [(ngModel)]="product.wholesaleprice"
                          (blur)="onUnitPriceBlur($event, product)"
                          [min]="product.costprice || product.buyingprice || 0"
                          step="0.01"
                          placeholder="Unit Price"
                        />
                        <input
                          *ngIf="isExchangeOrder"
                          class="form-control form-control-sm discount-input wholesale-input"
                          type="text"
                          [disabled]="true"
                          [value]="product.wholesaleprice | number: '1.2-2'"
                          placeholder="Unit Price"
                        />
                      </span>

                      <!-- Editable: excl-tax mode (default) -->
                      <span
                        *ngIf="
                          isSalesPriceEditEnabled &&
                          !isWholesaleMode &&
                          !isUnitPriceInclTax
                        "
                        class="text-end"
                      >
                        <input
                          *ngIf="!isExchangeOrder"
                          class="form-control form-control-sm discount-input text-end"
                          type="number"
                          [ngModel]="getEffectiveBasePrice(product)"
                          (blur)="onUnitPriceBlur($event, product)"
                          [min]="product.costprice || product.buyingprice || 0"
                          step="0.01"
                          placeholder="Unit Price"
                        />
                        <input
                          *ngIf="isExchangeOrder"
                          class="form-control form-control-sm discount-input text-end"
                          type="text"
                          [disabled]="true"
                          [value]="getEffectiveBasePrice(product) | number: '1.2-2'"
                          placeholder="Unit Price"
                        />
                      </span>
                      <!-- Editable: incl-tax mode — cashier types incl-tax price -->
                      <span
                        *ngIf="
                          isSalesPriceEditEnabled &&
                          !isWholesaleMode &&
                          isUnitPriceInclTax
                        "
                        class="text-end"
                      >
                        <input
                          *ngIf="!isExchangeOrder"
                          class="form-control form-control-sm discount-input text-end"
                          type="number"
                          [ngModel]="getEffectiveInclPrice(product)"
                          (blur)="onUnitPriceBlur($event, product)"
                          [min]="product.costprice || product.buyingprice || 0"
                          step="0.01"
                          placeholder="Unit Price (Incl. Tax)"
                        />
                        <input
                          *ngIf="isExchangeOrder"
                          class="form-control form-control-sm discount-input text-end"
                          type="text"
                          [disabled]="true"
                          [value]="
                            (getEffectiveInclPrice(product) != null
                              ? getEffectiveInclPrice(product)
                              : product.sellingprice
                            ) | number: '1.2-2'
                          "
                          placeholder="Unit Price (Incl. Tax)"
                        />
                      </span>

                      <!-- <span  *ngIf="
                          isSalesPriceEditEnabled &&
                          !isWholesaleMode &&
                          isUnitPriceInclTax && product.isbulk
                        " class="text-end">
<input
                          class="form-control form-control-sm discount-input text-end"
                          type="number"
                          [(ngModel)]="product.product_selling_price_incl"
                          [disabled]="isExchangeOrder"
                          (blur)="onUnitPriceBlur($event, product)"
                          [min]="product.costprice || product.buyingprice || 0"
                          step="0.01"
                          placeholder="Unit Price (Incl. Tax)"
                        />
                      </span> -->
                      <!-- Read-only: Mobile — always incl-tax (unchanged) -->
                      <span
                        *ngIf="
                          !isSalesPriceEditEnabled &&
                          industryConfig.table.industry == INDUSTRY_ENUM.MOBILE
                        "
                        class="price-text"
                      >
                        {{
                          (isWholesaleMode
                            ? product.wholesaleprice
                            : product.sellingpriceincltax
                          ) | number: "1.2-2"
                        }}
                      </span>
                      <!-- Read-only: Retail / Pharmacy / all non-Mobile — incl or excl tax based on setting -->
                      <span
                        *ngIf="
                          !isSalesPriceEditEnabled &&
                          industryConfig.table.industry != INDUSTRY_ENUM.MOBILE
                        "
                        class="price-text"
                      >
                        {{
                          (isWholesaleMode
                            ? product.wholesaleprice
                            : isUnitPriceInclTax
                              ? getEffectiveInclPrice(product)
                              : getEffectiveBasePrice(product)
                          ) | number: "1.2-2"
                        }}
                      </span>
                    </td>

                    <td class="text-end tax-cell">
                      {{ gettotaltaxval(product, 0) }}%
                    </td>
                    <td class="text-end net-value-cell">
                      <!-- re-created only when the value changes, which replays the pop animation -->
                      <span class="value-pop" *ngFor="let v of [getRowNetValue(product)]">{{ v | currency: "INR" }}</span>
                    </td>
                    <td
                      *ngIf="
                        !isExchangeOrder && products && products.length > 0
                      "
                      class="text-center action-cell"
                    >
                      <button
                        type="button"
                        class="icon-btn is-danger action-btn-delete"
                        (click)="
                          confirmDeleteItem(product); $event.stopPropagation()
                        "
                        title="Remove item from cart"
                        [attr.aria-label]="'Remove ' + product.name"
                      >
                        <i class="pi pi-trash"></i>
                      </button>
                    </td>
                  </tr>

                  <!-- Variant Selector Row (Phase 3) - Removed based on redesign, now inline rendering
                  <tr
                    *ngIf="hasVariantSelection(product)"
                    class="variant-selector-row"
                  >
                     Removed - using app-variant-selector inline
                  </tr> -->
                </ng-container>
              </tbody>
            </table>
          </ng-container>

          <!-- Full-area empty state when the cart has no items -->
          <app-empty-cart
            *ngIf="!products || products.length === 0"
            [barcodeEnabled]="isBarcodeEnabled"
          ></app-empty-cart>
        </div>
      </div>

      <!-- NEW IMPLEMENTATION: FooterActionButtonsComponent -->
      <app-footer-action-buttons
        [actions]="industryConfig.footerActions"
        [context]="this"
      ></app-footer-action-buttons>
    </div>
  </ng-container>
  <!-- end Retail/Mobile layout -->

  <!-- ═══════════════════════════════════════════════════════════════════════
       RESTAURANT layout (industry code 7)
       Vertical split: left = category grid, right = bill panel
       All business logic stays in DashboardComponent.
       Navbar, footer-action-buttons, and all dialogs are shared below.
       ═══════════════════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="isRestaurantIndustry">
    <app-restaurant-dashboard
      id="main-content"
      [cartProducts]="products"
      [catalogProducts]="filteredProducts"
      [actions]="industryConfig.footerActions"
      [context]="this"
      [uniqueItemsCount]="getUniqueItemsCount()"
      [totalQuantity]="getTotalCount()"
      [subtotal]="getSubtotal()"
      [isInterStateTaxOrder]="isInterStateTax()"
      [igst]="getIGST()"
      [cgst]="getCGST()"
      [sgst]="getSGST()"
      [taxAmount]="getCGST() + getSGST() + getIGST()"
      [productDiscount]="getDisctotal()"
      [enableOverAllDiscount]="enableOverAllDiscount"
      [isExchangeOrder]="isExchangeOrder"
      [overAllDiscountMode]="overAllDiscountMode"
      [overAllDiscountPercent]="overAllDiscountPercent"
      [overAllDiscount]="overAllDiscount"
      [discountModeOptions]="discountModeOptions"
      [subtotalAfterLineDiscount]="getSubtotalAfterLineDiscount()"
      [overAllDiscountAmount]="getOverAllDiscountAmount()"
      [roundOffAmount]="getRoundOffAmount()"
      [isMobileIndustry]="industryConfig.table.industry == INDUSTRY_ENUM.MOBILE"
      [freeAmount]="getFreeAmount()"
      [roundedTotal]="getRoundedTotal()"
      [profitAmount]="getProfitAmount()"
      [isQuotationMode]="isQuotationMode"
      [hasPendingVariantSelection]="hasPendingVariantSelection()"
      [isProcessingQuotation]="isProcessingQuotation"
      [canCompleteQuotation]="canCompleteQuotation()"
      [customerName]="customerName"
      [mobileNumber]="mobileNumber"
      [isUnitPriceInclTax]="isUnitPriceInclTax"
      (productSelected)="selectProduct($event)"
      (productRemoved)="confirmDeleteItem($event)"
      (increaseQty)="increaseQuantity($event)"
      (decreaseQty)="decreaseQuantity($event)"
      (processOrder)="handleProcessOrder()"
      (cancelBill)="handleEvent('F5')"
      (addCustomer)="($event)"
      (quickPayCash)="handleProcessOrder()"
      (quickPayUpi)="handleProcessOrder()"
      (quickPayCard)="handleProcessOrder()"
      (discountModeChanged)="onOverAllDiscountModeChange($event)"
      (discountValueChanged)="onOverAllDiscountChange($event)"
      (discountBlurred)="onOverAllDiscountBlur()"
    >
      <!-- Section 2: Barcode & Product Search -->
      <div
        search-bar
        class="section section-2 product-search"
        [class.disabled-section]="isExchangeOrder"
        [class.barcode-hidden]="!isBarcodeEnabled"
      >
        <!-- Left side: Barcode Search -->
        <div class="search-input-group barcode-search" *ngIf="isBarcodeEnabled">
          <div
            class="barcode-input-container"
            [class.delete-mode]="isDeleteMode"
          >
            <input
              type="text"
              class="form-control barcode-input"
              [class.delete-mode]="isDeleteMode"
              placeholder="Scan Barcode (Ctrl+1)"
              [(ngModel)]="barcodeInput"
              (keydown.enter)="onBarcodeEnter()"
              (input)="onBarcodeInput()"
              (blur)="onBarcodeBlur()"
              tabindex="1"
              #barcodeSearchInput
              [disabled]="isExchangeOrder"
              title="Press Ctrl+1 to focus here"
            />
            <div
              class="barcode-icon"
              (click)="!isExchangeOrder && toggleQR()"
              (onKeyPress)="!isExchangeOrder && toggleQR()"
              [class.disabled]="isExchangeOrder"
            >
              <svg
                width="24"
                height="16"
                viewBox="0 0 24 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0" y="0" width="1" height="16" fill="currentColor" />
                <rect x="2" y="0" width="1" height="16" fill="currentColor" />
                <rect x="4" y="0" width="2" height="16" fill="currentColor" />
                <rect x="7" y="0" width="1" height="16" fill="currentColor" />
                <rect x="9" y="0" width="1" height="16" fill="currentColor" />
                <rect x="11" y="0" width="2" height="16" fill="currentColor" />
                <rect x="14" y="0" width="1" height="16" fill="currentColor" />
                <rect x="16" y="0" width="1" height="16" fill="currentColor" />
                <rect x="18" y="0" width="2" height="16" fill="currentColor" />
                <rect x="21" y="0" width="1" height="16" fill="currentColor" />
                <rect x="23" y="0" width="1" height="16" fill="currentColor" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Right side: Product Search -->
        <div class="search-input-group product-search-group">
          <div class="product-input-container">
            <p-autoComplete
              [(ngModel)]="itemId"
              appendTo="body"
              panelStyleClass="enhanced-autocomplete-panel"
              scrollHeight="none"
              #autoCompleteInput
              [autofocus]="enableCursorFocus"
              [suggestions]="filteredProducts"
              [minLength]="1"
              [delay]="200"
              (completeMethod)="populateFilterProducts($event)"
              [showEmptyMessage]="true"
              [emptyMessage]="'No Match Found, Try Again'"
              (ngModelChange)="populateFilterProducts($event)"
              (onSelect)="selectProduct($event)"
              field="name"
              [dropdown]="true"
              [forceSelection]="false"
              [autoHighlight]="false"
              (keydown.enter)="enterSelected()"
              [disabled]="isExchangeOrder"
              placeholder="Product Name (Ctrl+2)"
              [tabindex]="2"
              styleClass="w-100"
              title="Press Ctrl+2 to focus here"
            >
              <ng-template pTemplate="header">
                <div class="autocomplete-header">
                  <div class="header-row">
                    <div class="header-cell code-col">CODE</div>
                    <div class="header-cell name-col">NAME</div>
                    <div class="header-cell brand-col">BRAND</div>
                    <div class="header-cell rack-col">RACK</div>
                    <div class="header-cell price-col">S.PRICE</div>
                    <div class="header-cell qty-col">QTY</div>
                  </div>
                </div>
              </ng-template>
              <ng-template let-product pTemplate="item" let-i="index">
                <div class="autocomplete-item">
                  <div class="item-row">
                    <div class="item-cell code-col">{{ i + 1 }}</div>
                    <div class="item-cell name-col">
                      <div class="product-name">{{ product.name }}</div>
                      <div class="product-details">
                        <div class="details-line">
                          <span class="barcode-text" *ngIf="isBarcodeEnabled"
                            >Barcode:
                            {{ displayBarcode(product) || "No Barcode" }}</span
                          >
                          <span
                            class="separator"
                            *ngIf="isBarcodeEnabled && isBatchEnabled"
                          >
                            |
                          </span>
                          <span class="batch-text" *ngIf="isBatchEnabled"
                            >Batch:
                            {{
                              product.batch == "opens012"
                                ? "--"
                                : product.batch || "--"
                            }}</span
                          >
                        </div>
                        <div class="details-line">
                          <span
                            class="category-text"
                            *ngIf="product.category"
                            >{{ product.category }}</span
                          >
                          <span
                            class="separator"
                            *ngIf="product.category && product.subcategory"
                          >
                            >
                          </span>
                          <span
                            class="subcategory-text"
                            *ngIf="product.subcategory"
                            >{{ product.subcategory }}</span
                          >
                          <span
                            class="separator"
                            *ngIf="
                              (product.category || product.subcategory) &&
                              product.sku
                            "
                          >
                            |
                          </span>
                          <span class="variant-text" *ngIf="product.sku"
                            >SKU: {{ product.sku }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="item-cell brand-col">
                      {{ product?.brand || "--" }}
                    </div>
                    <div class="item-cell rack-col">--</div>
                    <div class="item-cell price-col">
                      {{
                        (isWholesaleMode
                          ? product.wholesaleprice
                          : product.sellingprice
                        ) | currency: "INR" : "symbol" : "1.0-2"
                      }}
                    </div>
                    <div class="item-cell qty-col">
                      <span class="qty-badge">{{
                        product?.product_type === "Non Stock"
                          ? "NULL"
                          : getdecimalval(product?.qty) || 0
                      }}</span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-autoComplete>
            <div class="search-icon">
              <i class="pi pi-search"></i>
            </div>
          </div>
        </div>
      </div>
    </app-restaurant-dashboard>
  </ng-container>

  <!-- end Restaurant layout -->
</article>

<app-dashboard-right-panel
  *ngIf="!isRestaurantIndustry"
  [uniqueItemsCount]="getUniqueItemsCount()"
  [totalQuantity]="getTotalCount()"
  [freeQuantity]="getFreeCount()"
  [totalFreeAmount]="getTotalFreeAmount()"
  [subtotal]="getSubtotal()"
  [isInterStateTaxOrder]="isInterStateTax()"
  [igst]="getIGST()"
  [cgst]="getCGST()"
  [sgst]="getSGST()"
  [productDiscount]="getDisctotal()"
  [enableOverAllDiscount]="enableOverAllDiscount"
  [isFreeQtyEnabled]="isFreeQtyEnabled"
  [isExchangeOrder]="isExchangeOrder"
  [overAllDiscountMode]="overAllDiscountMode"
  [overAllDiscountPercent]="overAllDiscountPercent"
  [overAllDiscount]="overAllDiscount"
  [discountModeOptions]="discountModeOptions"
  [subtotalAfterLineDiscount]="getSubtotalAfterLineDiscount()"
  [overAllDiscountAmount]="getOverAllDiscountAmount()"
  [roundOffAmount]="getRoundOffAmount()"
  [isMobileIndustry]="industryConfig.table.industry == INDUSTRY_ENUM.MOBILE"
  [freeAmount]="getFreeAmount()"
  [roundedTotal]="getRoundedTotal()"
  [allowFreeOnlyCheckout]="hasOnlyFreeItemsInMobileCart()"
  [profitAmount]="getProfitAmount()"
  [isQuotationMode]="isQuotationMode"
  [canCompleteQuotation]="canCompleteQuotation()"
  [isProcessingQuotation]="isProcessingQuotation"
  [hasPendingVariantSelection]="hasPendingVariantSelection()"
  [isOrderBlocked]="isOrderBlocked"
  [isNetworkOffline]="isNetworkOffline"
  (discountModeChanged)="onOverAllDiscountModeChange($event)"
  (discountValueChanged)="onOverAllDiscountChange($event)"
  (discountBlurred)="onOverAllDiscountBlur()"
  (processOrderClicked)="handleProcessOrder()"
>
</app-dashboard-right-panel>

<!-- Restaurant Bill Panel — shown only for Restaurant industry -->
<app-restaurant-bill-panel
  *ngIf="isRestaurantIndustry"
  [products]="products"
  [uniqueItemsCount]="getUniqueItemsCount()"
  [totalQuantity]="getTotalCount()"
  [subtotal]="getSubtotal()"
  [isInterStateTaxOrder]="isInterStateTax()"
  [igst]="getIGST()"
  [cgst]="getCGST()"
  [sgst]="getSGST()"
  [taxAmount]="getCGST() + getSGST() + getIGST()"
  [productDiscount]="getDisctotal()"
  [enableOverAllDiscount]="enableOverAllDiscount"
  [isExchangeOrder]="isExchangeOrder"
  [overAllDiscountMode]="overAllDiscountMode"
  [overAllDiscountPercent]="overAllDiscountPercent"
  [overAllDiscount]="overAllDiscount"
  [discountModeOptions]="discountModeOptions"
  [subtotalAfterLineDiscount]="getSubtotalAfterLineDiscount()"
  [overAllDiscountAmount]="getOverAllDiscountAmount()"
  [roundOffAmount]="getRoundOffAmount()"
  [freeAmount]="getFreeAmount()"
  [roundedTotal]="getRoundedTotal()"
  [profitAmount]="getProfitAmount()"
  [isQuotationMode]="isQuotationMode"
  [canCompleteQuotation]="canCompleteQuotation()"
  [isProcessingQuotation]="isProcessingQuotation"
  [hasPendingVariantSelection]="hasPendingVariantSelection()"
  [isOrderBlocked]="isOrderBlocked"
  [customerName]="customerName"
  [mobileNumber]="mobileNumber"
  [isSalesDiscountEditEnabled]="isSalesDiscountEditEnabled"
  [discountMode]="discountMode"
  [isUnitPriceInclTax]="isUnitPriceInclTax"
  (increaseQtyClicked)="increaseQuantity($event)"
  (decreaseQtyClicked)="decreaseQuantity($event)"
  (removeItemClicked)="confirmDeleteItem($event)"
  (cancelBillClicked)="handleEvent('F5')"
  (holdReceiptClicked)="handleEvent('F4')"
  (processOrderClicked)="handleProcessOrder()"
  (cashPayClicked)="handleProcessOrder()"
  (upiPayClicked)="handleProcessOrder()"
  (cardPayClicked)="handleProcessOrder()"
  (itemDiscountChanged)="ondiscountvaluechange($event.event, $event.product)"
  (itemDiscountModeChanged)="onDiscountToggle($event)"
  (discountModeChanged)="onOverAllDiscountModeChange($event)"
  (discountValueChanged)="onOverAllDiscountChange($event)"
  (discountBlurred)="onOverAllDiscountBlur()"
>
</app-restaurant-bill-panel>

<app-hold-receipt-dialog
  [(visible)]="displayHoldNameDialog"
  [mobileNumber]="mobileNumber"
  [holdReceiptName]="holdReceiptName"
  [isMobileMandatory]="isMobileMandatory"
  (submitted)="onHoldReceiptSubmit($event)"
  (cancelled)="displayHoldNameDialog = false"
>
</app-hold-receipt-dialog>

<app-resume-receipt-dialog
  [(visible)]="savedReceiptsDialog"
  [savedReceipts]="savedReceipts"
  (resumed)="onReceiptResumed($event)"
  (closed)="savedReceiptsDialog = false"
>
</app-resume-receipt-dialog>

<app-split-bill-dialog
  [(visible)]="splitBillDialog"
  [products]="products"
  [roundedTotal]="getRoundedTotal()"
  (splitApplied)="onSplitApplied($event)"
  (dialogClosed)="splitBillDialog = false"
>
</app-split-bill-dialog>

<!-- Confirm item dialog-->

<div class="flex justify-content-center">
  <p-toast />
  <p-confirmDialog styleClass="pos-confirm-dialog">
    <ng-template pTemplate="message" let-message>
      <div
        class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border"
      >
        <i class="pi pi-exclamation-circle text-6xl text-primary-500"></i>
        <p>{{ message.message }}</p>
      </div>
    </ng-template>
  </p-confirmDialog>
</div>

<ng-container *ngIf="!userName">
  <p-dialog
    [(visible)]="displayModal"
    [modal]="true"
    [closeOnEscape]="false"
    [closable]="false"
    [style]="{ width: '50vw', minWidth: 'min(480px, 95vw)' }"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false"
    class="login-mask"
  >
    <app-login></app-login>
  </p-dialog>
</ng-container>

<div>
  <app-invoice-details-dialog
    [(visible)]="showInvoiceDialog"
    [enableCursorFocus]="enableCursorFocus"
    (invoiceSelected)="onInvoiceSelected($event)"
    (dialogClosed)="onInvoiceDialogClosed()"
  >
  </app-invoice-details-dialog>
</div>

<app-payment-total-dialog
  [(visible)]="showTotalDialog"
  [isQuotationMode]="isQuotationMode"
  [isExchangeOrder]="isExchangeOrder"
  [showExchangeConfirmation]="showExchangeConfirmation"
  [mobileNumber]="mobileNumber"
  (mobileNumberChange)="mobileNumber = $event"
  (mobileNumberModelChange)="onMobileNumberModelChange($event)"
  (mobileNumberBlur)="onMobileNumberInputBlur()"
  [customerName]="customerName"
  (customerNameChange)="customerName = $event"
  (customerNameModelChange)="onCustomerNameModelChange($event)"
  (customerNameBlur)="onCustomerNameInputBlur()"
  [doctorName]="doctorName"
  (doctorNameChange)="doctorName = $event"
  [doctorMobile]="doctorMobile"
  (doctorMobileChange)="doctorMobile = $event"
  [isMobileMandatory]="isMobileMandatory"
  [filteredCustomersForMobile]="filteredCustomersForMobile"
  [filteredCustomers]="filteredCustomers"
  (filterCustomersByMobileRequested)="filterCustomersByMobile($event)"
  (filterCustomersRequested)="filterCustomers($event)"
  (mobileSelectFromAutocomplete)="onMobileSelectFromAutocomplete($event)"
  (customerSelectFromAutocomplete)="onCustomerSelectFromAutocomplete($event)"
  [exactTotal]="getExactTotal()"
  [isAddToCreditSelected]="isSelected('Add to Credit')"
  (confirmExchangeAsCreditClicked)="confirmExchangeAsCredit()"
  (confirmExchangeAsRefundClicked)="confirmExchangeAsRefund()"
  (cancelExchangeConfirmationClicked)="cancelExchangeConfirmation()"
  (setActivePaymentTab)="setActivePaymentTab($event)"
  [showRedeemTab]="industryConfig.table.showRedeem"
  [isAnyPartPaymentEnabled]="isAnyPartPaymentEnabled()"
  [hasNonGSTProducts]="hasNonGSTProducts()"
  (cashAmountInput)="validateCashAmount()"
  (partPaymentCashToggle)="onPartPaymentToggle('Cash', $event)"
  [absoluteBalance]="getAbsoluteBalance()"
  (cardAmountInput)="validateCardAmount()"
  (partPaymentCardToggle)="onPartPaymentToggle('Card', $event)"
  (upiAmountInput)="validateUpiAmount()"
  (partPaymentUPIToggle)="onPartPaymentToggle('UPI', $event)"
  [roundedTotal]="getRoundedTotal()"
  (invoiceNumberInput)="onInvoiceNumberChange()"
  (redeemCreditAmountInput)="validateRedeemCreditAmount()"
  (redeemToggled)="onRedeemToggled($event)"
  (splitAmountInput)="onSplitAmountChange()"
  (upiPaymentRequest)="handleUpiPaymentRequest($event)"
  [upiQrCodeImage]="upiQrCodeImage"
  [upiQrExpirySeconds]="upiQrExpirySeconds"
  [paidAmount]="getPaidAmount()"
  [tipAmount]="getTipAmount()"
  [balanceAmount]="getBalanceAmount()"
  [balanceLabel]="getBalanceLabel()"
  [isBalanceNegative]="calculateBalance() < 0"
  [quotationValidityDate]="quotationValidityDate"
  (quotationValidityDateChange)="quotationValidityDate = $event"
  [minValidityDate]="minValidityDate"
  [maxValidityDate]="maxValidityDate"
  [products]="products"
  [isWholesaleMode]="isWholesaleMode"
  [isProcessingQuotation]="isProcessingQuotation"
  [canCompleteQuotation]="canCompleteQuotation()"
  (processQuotationClicked)="onProcessQuotationClicked()"
  [canCompletePayment]="canCompletePayment() && !isOrderBlocked"
  [exactTotalRoundOff]="getRoundOffAmount()"
  [currentPartPaymentAmount]="getCurrentPartPaymentAmount()"
  [remainingCreditAmount]="getRemainingCreditAmount()"
  (processPaymentClicked)="processPayment()"
  (closeTotalDialogClicked)="closeTotalDialog()"
  (dialogShow)="onPaymentDialogShow()"
  (dialogKeyDown)="onPaymentDialogKeyDown($event)"
  (upiQrExpired)="clearUpiQrState()"
  [billingPhase]="(billingGuardService.billingPhase$ | async)!"
>
</app-payment-total-dialog>

<!-- Quotation Options Dialog - shown before generating quotation PDF -->
<app-quotation-options-dialog
  [(visible)]="showQuotationOptionsDialog"
  [prefillCustomerName]="customerName"
  [prefillMobileNumber]="mobileNumber"
  [defaultValidityDate]="quotationValidityDate"
  (saved)="onQuotationOptionsSaved($event)"
></app-quotation-options-dialog>

<!-- Product details (row info icon). closable=false: Escape is handled by keyboard-navigation.service. -->
<p-dialog
  [(visible)]="showItemDetailDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-sm premium-dialog"
  [showHeader]="false"
>
  <div class="premium-dialog-container" *ngIf="selectedProductDetails">
    <!-- Header -->
    <div class="premium-header">
      <div class="premium-header-content">
        <h3 class="premium-title">Product Details</h3>
        <p class="premium-subtitle">{{ selectedProductDetails.name }}</p>
      </div>
      <button
        class="premium-close-btn"
        (click)="showItemDetailDialog = false"
        type="button"
        aria-label="Close"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="premium-body item-detail-body">
      <!-- Product Info Grid -->
      <div class="premium-grid">
        <div class="premium-field" >
          <span class="premium-label">Barcode</span>
          <span class="premium-value">{{
          (isBarcodeEnabled && displayBarcode(selectedProductDetails)) || 'No Barcode'
          }}</span>
        </div>

        <div class="premium-field">
          <span class="premium-label">HSN Code</span>
          <span class="premium-value">{{
            selectedProductDetails.hsncode || "N/A"
          }}</span>
        </div>
      </div>

      <!-- Pricing Section -->
      <div class="premium-section">
        <h3 class="premium-section-title">Pricing Information</h3>
        <div class="premium-pricing-grid">
          <div class="premium-price-card primary">
            <span class="price-label">Selling Price</span>
            <span class="price-value">{{
              (isWholesaleMode
                ? selectedProductDetails.wholesaleprice
                : selectedProductDetails.sellingprice
              ) | currency: "INR" : "symbol" : "1.2-2"
            }}</span>
          </div>

          <div class="premium-price-card">
            <span class="price-label">MRP</span>
            <span class="price-value">{{
              selectedProductDetails.sellingmrp
                | currency: "INR" : "symbol" : "1.2-2"
            }}</span>
          </div>

          <div class="premium-price-card success">
            <span class="price-label">Discount</span>
            <span
              class="price-value"
              *ngIf="selectedProductDetails.discount > 0"
            >
              {{ selectedProductDetails.discount }}%
            </span>
            <span
              class="price-value"
              *ngIf="
                selectedProductDetails.discount === 0 &&
                selectedProductDetails.discountval > 0
              "
            >
              {{
                selectedProductDetails.discountval
                  | currency: "INR" : "symbol" : "1.2-2"
              }}
            </span>
            <span
              class="price-value"
              *ngIf="
                selectedProductDetails.discount === 0 &&
                selectedProductDetails.discountval === 0
              "
            >
              {{ 0 | currency: "INR" : "symbol" : "1.2-2" }}
            </span>
          </div>

          <div class="premium-price-card">
            <span class="price-label">Tax</span>
            <span class="price-value"
              >{{ selectedProductDetails.tax || 0 }}%</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="premium-footer">
      <button
        class="premium-btn premium-btn-primary"
        (click)="showItemDetailDialog = false"
        type="button"
      >
        Close
      </button>
    </div>
  </div>
</p-dialog>

<!-- Sales & Quotations (F2). Chrome comes from styles/components/_dialogs.scss; each tab renders its own body and
     footer so the footer can reach the list component (template refs don't cross *ngIf boundaries). -->
<p-dialog
  [(visible)]="showTransactionDialog"
  styleClass="pos-dlg pos-dlg-xl premium-dialog premium-history-dialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
>
  <div class="premium-header">
    <div class="premium-header-content">
      <h3 class="premium-title">Sales &amp; Quotations</h3>
      <p class="premium-subtitle">Transaction and quotation records</p>
    </div>
    <button
      class="premium-close-btn"
      (click)="showTransactionDialog = false"
      type="button"
      aria-label="Close view history dialog"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="history-tab-bar" role="tablist">
    <button
      class="history-tab-item"
      [class.active]="activeHistoryTab === 0"
      [attr.aria-selected]="activeHistoryTab === 0"
      role="tab"
      (click)="activeHistoryTab = 0; onHistoryTabChange({ index: 0 })"
      type="button"
    >
      <i class="pi pi-receipt"></i>
      <span>Transactions</span>
    </button>
    <button
      *ngIf="industryConfig.table.showQuotation"
      class="history-tab-item"
      [class.active]="activeHistoryTab === 1"
      [attr.aria-selected]="activeHistoryTab === 1"
      role="tab"
      (click)="activeHistoryTab = 1; onHistoryTabChange({ index: 1 })"
      type="button"
    >
      <i class="pi pi-file-edit"></i>
      <span>Quotations</span>
    </button>
  </div>

  <!-- Transactions tab -->
  <ng-container *ngIf="activeHistoryTab === 0">
    <div class="history-panel-body">
      <app-sales-history-dialog
        #salesHistory
        [transactions]="transactions"
        [flattenedTransactions]="flattenedTransactions"
        [(selectedTransactionIndex)]="selectedTransactionIndex"
        [currentSearchTerm]="searchTerm"
        [showFooter]="false"
        (transactionSelect)="
          onTransactionSelectByIndex($event.index, $event.event)
        "
        (refreshRequested)="refreshHistoryData()"
        (printReceiptRequested)="
          printReceipt(false, getSelectedTransactionOrderId(), false, $event)
        "
        (downloadPdfRequested)="
          downloadInvoicePdf($event.pdfUrl, $event.invoiceNo, $event.event)
        "
      ></app-sales-history-dialog>
    </div>

    <div class="premium-footer">
      <button
        class="premium-btn premium-btn-secondary"
        (click)="salesHistory.markRefreshing(); refreshHistoryData()"
        [disabled]="salesHistory.refreshing"
        tabindex="501"
        type="button"
        [attr.aria-label]="'Refresh transaction list'"
      >
        <i
          class="pi"
          [ngClass]="salesHistory.refreshing ? 'pi-spin pi-spinner' : 'pi-refresh'"
        ></i>
        Refresh
      </button>
      <button
        *ngIf="whatsappShareAllowed"
        class="premium-btn premium-btn-secondary"
        [disabled]="
          selectedTransactionIndex < 0 ||
          !flattenedTransactions.length ||
          sharingTransactionWhatsapp
        "
        (click)="shareSelectedTransactionWhatsapp()"
        type="button"
        [attr.aria-label]="'Share selected invoice on WhatsApp'"
      >
        <i
          class="pi"
          [ngClass]="
            sharingTransactionWhatsapp ? 'pi-spin pi-spinner' : 'pi-whatsapp'
          "
        ></i>
        WhatsApp
      </button>
      <button
        class="premium-btn premium-btn-primary"
        tabindex="502"
        [disabled]="
          selectedTransactionIndex < 0 || !flattenedTransactions.length
        "
        (click)="
          printReceipt(
            false,
            getSelectedTransactionOrderId(),
            false,
            flattenedTransactions[selectedTransactionIndex]?.invoicepdf
          )
        "
        type="button"
      >
        <i class="pi pi-print"></i>
        Print Receipt
      </button>
    </div>
  </ng-container>

  <!-- Quotations tab -->
  <ng-container *ngIf="activeHistoryTab === 1">
    <div class="history-panel-body">
      <app-quotation-history-dialog
        #quotationHistory
        [quotations]="quotations"
        [filteredQuotations]="filteredQuotations"
        [selectedQuotationForView]="selectedQuotationForView"
        [selectedQuotationIndex]="selectedQuotationIndex"
        [(quotationSearchTerm)]="quotationSearchTerm"
        [showFooter]="false"
        (quotationSearch)="onQuotationSearch()"
        (clearSearch)="clearQuotationSearch()"
        (quotationSelect)="onQuotationSelect($event)"
        (editQuotationRequested)="editQuotation($event)"
        (placeOrderRequested)="placeOrderFromQuotation($event)"
        (viewQuotationRequested)="viewQuotation()"
        (refreshRequested)="refreshHistoryData()"
      ></app-quotation-history-dialog>
    </div>

    <div class="premium-footer">
      <button
        class="premium-btn premium-btn-secondary"
        (click)="quotationHistory.markRefreshing(); refreshHistoryData()"
        [disabled]="quotationHistory.refreshing"
        tabindex="503"
        type="button"
        [attr.aria-label]="'Refresh quotation list'"
      >
        <i
          class="pi"
          [ngClass]="quotationHistory.refreshing ? 'pi-spin pi-spinner' : 'pi-refresh'"
        ></i>
        Refresh
      </button>
      <button
        class="premium-btn premium-btn-primary"
        tabindex="504"
        [disabled]="!selectedQuotationForView"
        (click)="viewQuotation()"
        type="button"
      >
        <i class="pi pi-eye"></i>
        View Quotation
      </button>
    </div>
  </ng-container>
</p-dialog>

<app-offer-group-customer-dialog
  [(visible)]="showOfferGroupCustomerDialog"
  [loadingCustomers]="loadingCustomers"
  [(customerMobile)]="customerMobile"
  [filteredCustomersForOfferGroup]="filteredCustomersForOfferGroup"
  [selectedCustomer]="selectedCustomer"
  [selectedOfferGroupId]="selectedOfferGroupId"
  (filterCustomers)="onOfferGroupFilterCustomers($event)"
  (mobileSelect)="onOfferGroupMobileSelect($event)"
  (proceedWithCustomerRequested)="onProceedWithCustomer()"
  (proceedWithoutCustomerRequested)="onProceedWithoutCustomer()"
  (tabNavigation)="handleOfferGroupDialogTabNavigation($event)"
></app-offer-group-customer-dialog>

<!-- Warranty Date Dialog (mobile). closable=false: Escape is handled by keyboard-navigation.service. -->
<p-dialog
  [(visible)]="showWarrantyDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-sm premium-dialog"
  [showHeader]="false"
>
  <div class="premium-dialog-container">
    <div class="premium-header">
      <div class="premium-header-content">
        <h3 class="premium-title">Warranty Date</h3>
        <p class="premium-subtitle">
          {{ selectedProductForWarranty?.name }}
        </p>
      </div>
      <button class="premium-close-btn" (click)="closeWarrantyDialog()" type="button" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="premium-body">
      <div class="item-dialog-field">
        <p-calendar
          [(ngModel)]="tempWarrantyDate"
          dateFormat="dd-mm-yy"
          [minDate]="today"
          [showIcon]="true"
          [inline]="false"
          appendTo="body"
          placeholder="Select warranty end date"
          styleClass="w-full"
        ></p-calendar>
        <div class="warranty-presets">
          <button
            *ngFor="let months of [3, 6, 12]"
            class="warranty-preset-btn"
            (click)="setWarrantyMonths(months)"
            type="button"
          >
            +{{ months }} months
          </button>
        </div>
      </div>
    </div>

    <div class="premium-footer">
      <button class="premium-btn premium-btn-secondary" (click)="clearWarranty()" type="button">
        <i class="pi pi-trash"></i>
        Clear
      </button>
      <button class="premium-btn premium-btn-primary" (click)="saveWarranty()" type="button">
        <i class="pi pi-check"></i>
        Save
      </button>
    </div>
  </div>
</p-dialog>

<!-- Product Description Dialog. closable=false: Escape is handled by keyboard-navigation.service. -->
<p-dialog
  [(visible)]="showDescriptionDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-sm premium-dialog"
  [showHeader]="false"
  (onShow)="focusDescriptionTextarea(descriptionTextarea)"
>
  <div class="premium-dialog-container">
    <!-- Header -->
    <div class="premium-header">
      <div class="premium-header-content">
        <h3 class="premium-title">Product Description</h3>
        <p class="premium-subtitle">
          {{ selectedProductForDescription?.name }}
        </p>
      </div>
      <button
        class="premium-close-btn"
        (click)="closeDescriptionDialog()"
        type="button"
        aria-label="Close"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="premium-body">
      <div class="item-dialog-field">
        <textarea
          id="productDescription"
          class="item-dialog-textarea"
          [(ngModel)]="tempDescription"
          placeholder="Enter product description (max 200 characters)"
          maxlength="200"
          rows="4"
          #descriptionTextarea
        ></textarea>
        <div class="description-footer">
          <small class="char-counter"
            >{{ tempDescription?.length || 0 }}/200 characters</small
          >
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="premium-footer">
      <button
        class="premium-btn premium-btn-secondary"
        (click)="closeDescriptionDialog()"
        type="button"
      >
        <i class="pi pi-times"></i>
        Cancel
      </button>
      <button
        class="premium-btn premium-btn-primary"
        (click)="saveDescription()"
        type="button"
      >
        <i class="pi pi-check"></i>
        Save
      </button>
    </div>
  </div>
</p-dialog>

<p-confirmDialog
  key="positionDialog"
  [position]="'top'"
  rejectButtonStyleClass="p-button-outlined"
  styleClass="pos-confirm-dialog"
/>

<!-- Cash In Dialog - shown after login if user hasn't punched in -->
<p-dialog
  [(visible)]="showCashInDialog"
  [modal]="true"
  [closeOnEscape]="false"
  [closable]="false"
  [showHeader]="false"
  [baseZIndex]="10001"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-md premium-dialog cash-in-dialog"
>
  <!-- Not closable: the cashier saves the opening count (body and footer come from app-cash-denomination) -->
  <div class="premium-header">
    <div class="premium-header-content">
      <h3 class="premium-title">Opening Cash Entry</h3>
      <p class="premium-subtitle">Count the cash in the drawer before you start billing</p>
    </div>
  </div>
  <!-- *ngIf: projected content is created even while the dialog is closed, and its init calls the denomination APIs -->
  <app-cash-denomination
    *ngIf="isDenominationEnabled"
    [mode]="'dialog'"
    [initialTab]="'dayIn'"
    [canSkip]="false"
    (onComplete)="onCashInComplete($event)"
  ></app-cash-denomination>
</p-dialog>
